<div id="app-heat-map-chart-pop-div" class="app-heat-map-chart-pop-div"></div>
